import { useMemo } from 'react';

const useFrontPlugin = () => {
  const isFrontPlugin = useMemo(() => {
    return (
      window.self !== window.top
      // authToken === import.meta.env.VITE_PUBLIC_FRONT_PLUGIN_SECRET
    );
  }, []);

  return {
    isFrontPlugin,
  };
};

export default useFrontPlugin;
